<template>
    <div class="app-main" :class="{'app-fullscreen': fullscreen, 'bg-white': bgWhite}" id="appMain">
        <router-view v-if="isRouterAlive" />
    </div>
</template>

<script>
export default {
    data() {
        return {
            isRouterAlive: true,
            fullscreenPaths: ['/dealer/index', '/dealer/goods/list'],
            bgWhites: ['/dealer/index', '/dealer/goods/list'],
        }
    },
    provide() {
        return {
            reload: this.reload
        }
    },
    computed: {
        curPath() {
            return this.$route.path
        },
        fullscreen() {
            if (this.curPath) {
                return this.fullscreenPaths.indexOf(this.curPath) >= 0
            } else {
                return false
            }
        },
        bgWhite() {
            if (this.curPath) {
                return this.bgWhites.indexOf(this.curPath) >= 0
            } else {
                return false
            }
        }
    },
    // watch: {
    //     $route: {
    //         handler: function (route) {
    //             console.log(route);
    //         },
    //         immediate: true
    //     }
    // },
    methods: {
        reload() {
            this.isRouterAlive = false
            this.$nextTick(() => {
                this.isRouterAlive = true
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.app-main {
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0;
    width: 1132px;
    min-height: 100vh;
    position: relative;
    &.app-fullscreen {
        width: 100%;
    }
    &.bg-white {
        background-color: #fff;
    }
}
</style>